module.exports = __webpack_public_path__ + "img/ipad-en-3.b1776d7.jpg";